module.exports = "https://static.energy5.com/_next/static/images/header-73b267c44175839bf4aab51443d100e1.png";